import groq from 'groq'

import { mediaAsset } from '../../../projections/mediaAsset'
import { callToAction } from '../../../projections/callToAction.js'

export const header = groq`
 _type,
  title,
  subtitle,

  'persons': ^.articleSetup.persons[]{
    _key,
    "authorName": person->name,
    "authorRole": person->role,
    "authorImage": person->media[_type == 'imageAsset'][0]{
      ...${mediaAsset()}
    },
    "person": person->{
      name,
      role,
      media[]{
        ...${mediaAsset()}
      }
    }
  },

  "category": ^.articleSetup.category->name,
  "date": ^.articleSetup.date,
  "readTime": ^.sections[1]{
    "time":round(length(pt::text(content)) / 5 / 180 ),
  }.time,

  media[0]{...${mediaAsset()}},
  tldr{
    "title": coalesce(
      title,
      *[_type == 'sharedContent'][0].articles.TLDRLabel,
      *[_type == 'sharedContent'][0].articles.tldrLabel
    ),
    summary
  },
  sideCta{
    "title": coalesce(
      title,
      *[_type == 'sharedContent'][0].articles.callToActionTitle,
    ),
    cta{...${callToAction()}},
  }
`
